import three from './three'
import consoleText from './console-text'

three()
consoleText('Toby Ryuk')
